import Joi from 'joi';
import { mongoObjectIdSchema } from './common.js';
import { getWordCount } from '../utils/global.jsx';

export const nameSchema = Joi.string().trim().required().min(2).max(100).messages({
  'any.required': 'Please enter name for Email Template',
  'string.min': 'Please enter name for Email Template',
  'string.max': 'Please reduce the length of name for Email Template',
  'string.empty': 'Please enter name for Email Template',
});

export const subjectSchema = Joi.string()
  .trim()
  .min(2)
  .custom((value, helpers) => {
    const wordCount = getWordCount(value);
    if (wordCount <= 20) {
      return value; // The value is valid
    } else {
      return helpers.error('string.maxWords');
    }
  }, 'Custom validation')
  .messages({
    'any.required': 'Please enter subject for Email Template',
    'string.min': 'Subject too short!',
    'string.maxWords': 'Subject too long, try shorter?',
    'string.empty': 'Please enter subject for Email Template',
  });

export const emailBodySchema = Joi.string()
  .trim()
  .required()
  .min(2)
  .custom((value, helpers) => {
    const wordCount = getWordCount(value);
    if (wordCount <= 1000) {
      return value; // The value is valid
    } else {
      return helpers.error('string.maxWords');
    }
  }, 'Custom validation')
  .messages({
    'any.required': 'Please enter body for Email Template',
    'string.min': 'Email Body too short!',
    'string.maxWords': 'Email Body too long, try shorter?',
    'string.empty': 'Please enter body for Email Template',
  });

export const emailTypeSchema = Joi.string().messages({
  'any.required': 'Email type is required.',
});

export const sendFromSchema = Joi.string()
  .email({ tlds: { allow: false } })
  .messages({});
export const createUserInboundEmailTemplateSchema = Joi.object({
  name: nameSchema,
  subject: subjectSchema.allow(null),
  emailBody: emailBodySchema,
  emailType: emailTypeSchema,
});

export const updateUserInboundEmailTemplateSchema = createUserInboundEmailTemplateSchema.keys({
  inboundEmailTemplateId: mongoObjectIdSchema,
  sendFrom: sendFromSchema,
});

export const createSystemInboundEmailTemplateSchema = Joi.object({
  name: nameSchema,
  subject: subjectSchema.required(),
  emailBody: emailBodySchema,
  emailType: emailTypeSchema,
});

export const updateSystemInboundEmailTemplateSchema = createSystemInboundEmailTemplateSchema.keys({
  inboundEmailTemplateId: mongoObjectIdSchema,
  sendFrom: sendFromSchema,
});

export const createUserUsageRightsTemplateSchema = Joi.object({
  name: nameSchema,
  body: emailBodySchema,
  emailType: emailTypeSchema,
});

export const createSystemUsageRightsTemplateSchema = Joi.object({
  name: nameSchema,
  body: emailBodySchema,
  emailType: emailTypeSchema,
});


export const updateSystemUsageRightsTemplateSchema = Joi.object({
  id: mongoObjectIdSchema,
  emailType: emailTypeSchema.optional(),
  name: nameSchema.optional(),
  body: emailBodySchema.optional(),
});

export const updateUserUsageRightsTemplateSchema = Joi.object({
  id: mongoObjectIdSchema,
  emailType: emailTypeSchema.optional(),
  name: nameSchema.optional(),
  body: emailBodySchema.optional(),
});
